<template>
  <div id="hereApiPolygonManager">
    <div id="mapView"></div>
    <div class="buttons">
      <button class="btn btn-primary btn-sm" @click="loadZones">
        {{$t('zone.load_zone')}}
      </button>
      <button class="btn btn-secondary btn-sm" v-if="lineStrings.length > 0 && lineString && lineString.getLatLngAltArray().length === 0" @click="exportZones">
        {{$t('zone.update_zone')}}
      </button>
      <button class="btn btn-secondary btn-sm" v-if="lineString && lineString.getLatLngAltArray().length > 0" @click="exportNewZone">
        {{$t('zone.new_zone')}}
      </button>
      <button class="btn btn-secondary btn-sm" v-if="lineString && lineString.getLatLngAltArray().length > 0" @click="reset">
        {{$t('zone.reset')}}
      </button>
    </div>
    <div class="zones" v-if="lineStrings.length > 0">
      <div class="title">{{$t('settings.delivery_zones')}}</div>
      <div class="zone" v-for="(group, groupIndex) of groups" v-show="group.type === 'polygon'">
        <div class="color" :style="{ backgroundColor: group.color }"></div>
        <div class="name">Zone #{{groupIndex + 1}} <template v-if="group.name"> - {{group.name}}</template></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hereApiPolygonManager",

  props: {
    zones: Array
  },

  data() {
    return {
      mainGroups: [],
      lineStrings: [],
      lineString: null,
      polygon: null,
      colors: [
        "rgba(224,25,25,0.5)","rgba(22,167,224,0.5)","rgba(99,9,184,0.5)","rgba(227,151,20,0.5)","rgba(4,189,75,0.5)",
        "rgba(32,4,189,0.5)","rgba(171,4,189,0.5)","rgba(25,182,155,0.5)","rgba(171,201,0,0.5)","rgba(232,67,172,0.5)",
        "rgba(9,112,35,0.5)", "rgba(255,238,87,0.5)", "rgba(182,158,255,0.5)", "rgba(255,171,235,0.5)", "rgba(158,255,161,0.5)",
        "rgba(77,6,82,0.5)", "rgba(128,128,128,0.5)", "rgba(0,0,0,0.5)", "rgba(252,90,35,0.5)", "rgba(135,79,0,0.5)"
      ],
      newLineStringGroup: null,
      map: null
    }
  },

  mounted() {
    this.initializeHereAPI();

    setTimeout(() => {
      this.initializeLineString();
      this.loadZones();
    }, 300);
  },

  computed: {
    groups() {
      return this.zones.map(z =>  {
        let polygons = (z.polygons && z.type === "polygon" && typeof z.polygons === "string") ? JSON.parse(z.polygons) : z.polygons;
        return {
          polygons: z.polygons ? polygons : [],
          type: z.type,
          name: z.name,
          color: this.colors[this.zones.indexOf(z) % 20]
        }
      });
    }
  },

  methods: {
    initializeLineString() {
      this.lineString = new H.geo.LineString([]);
      this.newLineStringGroup = null;
    },
    initializeHereAPI() {
      // Connexion à Here API
      let platform;
      try {
        platform = new H.service.Platform({
          apikey: "YcweJ0n-XSvKeqB81LELcNfh8kCiZce2Uj_LOUqWhdg"
        });
      } catch (e) {
        console.log('error init here api', e)
      }

      if (!platform) {
        return;
      }

      // Création de la carte
      let defaultLayers = platform.createDefaultLayers();
      this.map = new H.Map(
          document.getElementById("mapView"),
          defaultLayers.vector.normal.map, {
            center: { lat: 33.8121, lng: -117.9190 },
            zoom: 10
          }
      );
      window.addEventListener('resize', () => {
        setTimeout(() => {
          if (this.map) {
            this.map.getViewPort().resize();
          }
        }, 100);
      });

      let behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
      let ui = H.ui.UI.createDefault(this.map, defaultLayers);
      this.map.setCenter({ lat:46.760910,lng:-71.224888 });

      // Création de l'événement de clic
      this.initializeLineString();

      this.map.addEventListener("tap", (e) => {
        if (this.newLineStringGroup) {
          let index = this.mainGroups.indexOf(this.newLineStringGroup);
          this.mainGroups.splice(index, 1);
          this.map.removeObject(this.newLineStringGroup);
          this.newLineStringGroup = null;
        }
        let coords = this.map.screenToGeo(e.currentPointer.viewportX, e.currentPointer.viewportY);
        this.lineString.pushLatLngAlt(coords.lat, coords.lng, 0);
        this.addPolygonToMap(this.lineString, null, true);
      });
    },

    loadZones() {
      this.removeMapObject();
      this.lineStrings = [];
      for (let group of this.groups) {
        let lineString = new H.geo.LineString([]);
        for (let code of group.polygons) {
          lineString.pushLatLngAlt(code.lat, code.lng, 0);
        }
        if (this.groups.length > 0) {
          this.map.setCenter({
            lat: this.groups[0].polygons[0].lat,
            lng: this.groups[0].polygons[0].lng
          });
          this.map.setZoom(12);
        }
        this.addPolygonToMap(lineString, group.color);
        this.lineStrings.push(lineString);
      }
    },

    async exportZones() {
      let response = await showConfirmation(this.$t("warning"), this.$t("settings.polygon_warning"),
          this.$t("settings.polygon_warning_button_ok"), this.$t("settings.polygon_warning_button_cancel"));
      if (response) {
        this.$emit("changed", this.lineStrings.map(l => { return this.getStrings(l); }));
        setTimeout(() => {
          this.loadZones();
          toast(this.$t("zone.update_success"), "success");
        }, 100);
      } else {
        this.loadZones();
      }
    },

    async exportNewZone() {
      let response = await showConfirmation(this.$t("warning"), this.$t("settings.polygon_warning"),
          this.$t("settings.polygon_warning_button_ok"), this.$t("settings.polygon_warning_button_cancel"));
      if (response) {
        this.$emit("new", this.getStrings(this.lineString));
        setTimeout(() => {
          this.loadZones();
          toast(this.$t("zone.add_success"), "success");
          this.initializeLineString();
        }, 100);
      } else {
        this.loadZones();
      }
    },

    removeMapObject() {
      for (let group of this.mainGroups) {
        this.map.removeObject(group);
      }
      this.mainGroups = [];
    },

    getStrings(lineString) {
      let output = [];
      let strings = lineString.getLatLngAltArray();
      for (let i = 0; i < strings.length / 3; i++) {
        output.push({
          lat: strings[i * 3],
          lng: strings[i * 3 + 1]
        });
      }
      return JSON.stringify(output);
    },

    reset() {
      this.initializeLineString();
      this.loadZones();
    },

    addPolygonToMap(lineString, color, newLineString) {
      if (lineString.getLatLngAltArray().length === 0) {
        return;
      }

      let svgCircle = '<svg width="20" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
          '<circle cx="10" cy="10" r="7" fill="transparent" stroke="grey" stroke-width="2"/>' +
          '</svg>';

      // DOC resize polygon https://developer.here.com/documentation/examples/maps-js/resizable-geoshapes/resizable-polygon
      let polygon = new H.map.Polygon(new H.geo.Polygon(lineString), {
        style: {
          fillColor: color ? color : "rgba(255, 0, 0, 0.5)",
          strokeColor: color || "#ff0000",
          lineWidth: 3
        }
      });
      let verticeGroup = new H.map.Group({
        visibility: false
      });
      let newGroup = new H.map.Group({
        volatility: false, // mark the group as volatile for smooth dragging of all it's objects
        objects: [polygon, verticeGroup]
      });

      let polygonTimeout;

      polygon.draggable = true;

      polygon.getGeometry().getExterior().eachLatLngAlt((lat, lng, alt, index) => {
        let vertice = new H.map.Marker(
            { lat, lng },
            { icon: new H.map.Icon(svgCircle, {anchor: {x: 10, y: 10}}) }
        );
        vertice.draggable = true;
        vertice.setData({'verticeIndex': index})
        verticeGroup.addObject(vertice);
      });

      if (newLineString) {
        this.newLineStringGroup = newGroup;
      }
      this.map.addObject(newGroup);
      this.mainGroups.push(newGroup);

      // add group with polygon and it's vertices (markers) on the map
      newGroup.addEventListener('pointerenter', function() {
        if (polygonTimeout) {
          clearTimeout(polygonTimeout);
          polygonTimeout = null;
        }
        // show vertice markers
        verticeGroup.setVisibility(true);
      }, true);


      // event listener for main group to hide vertice markers if moved out with mouse (or released finger on touch devices)
      // the vertice markers are hidden on touch devices after specific timeout
      newGroup.addEventListener('pointerleave', (evt) => {
        let timeout = (evt.currentPointer.type == 'touch') ? 1000 : 0;

        // hide vertice markers
        polygonTimeout = setTimeout(function() {
          verticeGroup.setVisibility(false);
        }, timeout);
      }, true);

      // event listener for vertice markers group to change the cursor to pointer
      verticeGroup.addEventListener('pointerenter', (evt) => {
        document.body.style.cursor = 'pointer';
      }, true);

      // event listener for vertice markers group to change the cursor to default
      verticeGroup.addEventListener('pointerleave', (evt) => {
        document.body.style.cursor = 'default';
      }, true);

      // event listener for vertice markers group to resize the geo polygon object if dragging over markers
      verticeGroup.addEventListener('drag', (evt) => {
        let pointer = evt.currentPointer;
        let geoLineString = polygon.getGeometry().getExterior();
        let geoPoint = this.map.screenToGeo(pointer.viewportX, pointer.viewportY);

        // set new position for vertice marker
        evt.target.setGeometry(geoPoint);

        // set new position for polygon's vertice
        geoLineString.removePoint(evt.target.getData()['verticeIndex']);
        geoLineString.insertPoint(evt.target.getData()['verticeIndex'], geoPoint);
        polygon.setGeometry(new H.geo.Polygon(geoLineString));

        // stop propagating the drag event, so the map doesn't move
        evt.stopPropagation();
      }, true);
    }
  }
}
</script>

<style lang="scss" scoped>
#hereApiPolygonManager {
  position: relative;
}

#mapView {
  width: 100%;
  height: 600px;
}

.buttons {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;

  .btn {
    margin-right: 10px;
  }
}

.zones {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255,255,255,1);
  padding: 5px 10px;
  font-size: 11px;
  border-radius: 5px;

  .title {
    font-weight: bold;
    padding-bottom: 4px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 4px;
  }

  .zone {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      padding-bottom: 5px;
    }
  }

  .color {
    $size: 8px;
    width: $size;
    height: $size;
    border-radius: 100%;
    margin-right: 8px;
  }
}
</style>
